import './application/bootstrap.sass'

import 'unpoly/unpoly.js'
import 'unpoly/unpoly.css'
import 'unpoly/unpoly-bootstrap5.css'
import 'unpoly/unpoly-bootstrap5.js'

import  _ from 'underscore'
window._ = _

import './application/jquery.js'
import 'jquery-fieldselection/jquery-fieldselection'
import 'jquery.selection.custom'
import 'jquery-ujs'
import 'rangyinputs'
import 'jquery-ui'
import 'jquery.fileupload'

import 'highlight.js/styles/tomorrow.css'

// Fonts
import 'makandra'
import 'bootstrap-icons-font'
import 'roboto'
import 'roboto-mono'

import './stylesheets/**/*.sass'
import './javascripts/**/*.js'
